import './product/components/AccessBenefitsGrid';
import { loyaltyInit, runPageStartUpScripts } from '../utils/loyalty-helpers';

loyaltyInit(false);

// ? [REVISIT] Greenlighted by @daltomania since we don't have time to rebuilt. I would prefer more robust implementation, possibly with React;
window.addEventListener('DOMContentLoaded', runPageStartUpScripts);
